import Vue from "vue";
import Vuex from "vuex";
import axios from "axios";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    editing: undefined,
    record: {
      id: undefined,
      folio: undefined,
      context: {},
      aggression_datetime: undefined,
      verification_datetime: undefined,
      alert_link: undefined,
      aggression_type: [],
      aggression_subtype: [],
      details: undefined,
      state: undefined,
      municipality: undefined,
      place: undefined,
      address: undefined,
      lat: undefined,
      lng: undefined,
      victims: [],
      updates: [],
      reviews: [],
      public: true,
      edit_reason: undefined,
      edit_comments: undefined,
      review_reason: undefined,
      review_comments: undefined
    },
    aggressionsTypes: [
      {
        slug: "allanamiento",
        title: "Allanamiento",
        subtypes: [
          {
            slug: "de-hogares",
            title: "De hogares"
          },
          {
            slug: "de-oficinas",
            title: "De oficinas"
          }
        ]
      },
      {
        slug: "amenaza",
        title: "Amenaza",
        subtypes: [
          {
            slug: "a-familiares-o-amistades",
            title: "A familiares o amistades"
          },
          {
            slug: "a-la-integridad",
            title: "A la integridad"
          },
          {
            slug: "violencia-sexual",
            title: "Violencia sexual"
          },
          {
            slug: "al-medio-de-comunicacion",
            title: "Al medio de comunicación"
          },
          {
            slug: "de-desaparicion",
            title: "De desaparición"
          },
          {
            slug: "de-acciones-legales",
            title: "De acciones legales"
          },
          {
            slug: "de-muerte",
            title: "De muerte"
          },
          {
            slug: "maltrato-o-muerte-de-animales-domesticos-guardia-o-guia",
            title: "Maltrato o muerte de animales domésticos guardia o guía"
          }
        ]
      },
      {
        slug: "asesinato",
        title: "Asesinato",
        subtypes: [
          {
            slug: "homicidio",
            title: "Homicidio"
          },
          {
            slug: "feminicidio",
            title: "Feminicidio"
          },
          {
            slug: "crimen-de-odio",
            title: "Crimen de odio"
          },
          {
            slug: "ejecucion-extrajudicial",
            title: "Ejecución extrajudicial"
          }
        ]
      },
      {
        slug: "ataque-a-bienes-materiales",
        title: "Ataque a bienes materiales",
        subtypes: [
          {
            slug: "dano-o-destruccion-de-equipo-o-material-de-trabajo",
            title: "Daño o destrucción de equipo o material de trabajo"
          },
          {
            slug:
              "dano-o-destruccion-de-bienes-muebles-que-no-son-material-de-trabajo",
            title:
              "Daño o destrucción de bienes muebles que no son material de trabajo"
          },
          {
            slug: "robo-de-equipo-o-material-de-trabajo",
            title: "Robo de equipo o material de trabajo"
          },
          {
            slug: "robo-de-bienes-muebles-que-no-son-material-de-trabajo",
            title: "Robo de bienes muebles que no son material de trabajo"
          },
          {
            slug: "robo-de-bienes-inmuebles-(despojo)",
            title: "Robo de bienes inmuebles (despojo)"
          },
          {
            slug: "daño-o-destruccion-de-bienes-inmuebles",
            title: "Daño o destrucción de bienes inmuebles"
          }
        ]
      },
      {
        slug: "ataque-fisico",
        title: "Ataque físico",
        subtypes: [
          {
            slug: "tentativa-de-asesinato",
            title: "Tentativa de asesinato"
          },
          {
            slug: "lesiones",
            title: "Lesiones"
          },
          {
            slug: "violencia-sexual",
            title: "Violencia sexual"
          },
          {
            slug: "violacion-sexual",
            title: "Violación sexual"
          }
        ]
      },
      {
        slug: "desaparicion",
        title: "Desaparición",
        subtypes: [
          {
            slug: "forzada",
            title: "Forzada"
          },
          {
            slug: "por-particulares",
            title: "Por particulares"
          }
        ]
      },
      {
        slug: "desplazamiento-forzado",
        title: "Desplazamiento forzado",
        subtypes: [
          {
            slug: "interno",
            title: "Interno"
          },
          {
            slug: "externo",
            title: "Externo"
          }
        ]
      },
      {
        slug: "privacion-de-la-libertad",
        title: "Privación de la libertad",
        subtypes: [
          {
            slug: "detencion-arbitraria",
            title: "Detención arbitraria"
          },
          {
            slug: "privacion-ilegal-de-la-libertad",
            title: "Privación ilegal de la libertad"
          },
          {
            slug: "secuestro",
            title: "Secuestro"
          }
        ]
      },
      {
        slug: "tortura-o-tratos-crueles-inhumanos-y-degradantes",
        title: "Tortura o tratos crueles, inhumanos y degradantes",
        subtypes: [
          {
            slug: "tortura",
            title: "Tortura"
          },
          {
            slug: "tratos-crueles-inhumanos-y-degradantes",
            title: "Tratos crueles, inhumanos y degradantes"
          },
          {
            slug: "tortura-sexual",
            title: "Tortura sexual"
          }
        ]
      },
      {
        slug: "intimidacion-y-hostigamiento",
        title: "Intimidación y hostigamiento",
        subtypes: [
          {
            slug: "difusion-de-informacion-sin-consentimiento",
            title: "Difusión de información sin consentimiento"
          },
          {
            slug: "doxxing",
            title: "DOXXING"
          },
          {
            slug: "doxxing-con-componente-de-genero",
            title: "DOXXING con componente de género"
          },
          {
            slug: "persecucion",
            title: "Persecución"
          },
          {
            slug: "presencia-de-personas",
            title: "Presencia de personas"
          },
          {
            slug: "campana-de-desprestigio",
            title: "Campaña de desprestigio"
          },
          {
            slug: "toma-de-videos-o-fotografias-no-autorizadas",
            title: "Toma de videos o fotografías no autorizadas"
          },
          {
            slug: "comunicaciones-intimidatorias",
            title: "Comunicaciones intimidatorias"
          },
          {
            slug: "actos-intimidatorios",
            title: "Actos intimidatorios"
          }
        ]
      },
      {
        slug: "uso-ilegitimo-del-poder-publico",
        title: "Uso ilegítimo del poder público",
        subtypes: [
          {
            slug: "criminalizacion",
            title: "Criminalización"
          },
          {
            slug: "estigmatizacion-por-medio-de-comunicacion-oficial",
            title: "Estigmatización por medio de comunicación oficial"
          },
          {
            slug: "hostigamiento-judicial-por-la-via-civil",
            title: "Hostigamiento judicial por la vía civil"
          },
          {
            slug: "hostigamiento-ministerial-o-judicial-por-la-via-penal",
            title: "Hostigamiento ministerial o judicial por la vía penal"
          },
          {
            slug: "hostigamiento-administrativo",
            title: "Hostigamiento administrativo"
          },
          {
            slug:
              "suspension-denegacion-o-condicionamiento-de-publicidad-oficial",
            title:
              "Suspensión, denegación o condicionamiento de publicidad oficial"
          },
          {
            slug: "filtracion-de-informacion-en-un-proceso-legal",
            title: "Filtración de información en un proceso legal"
          },
          {
            slug: "hostigamiento-electoral",
            title: "Hostigamiento electoral"
          }
        ]
      },
      {
        slug: "bloqueo-o-alteracion-de-informacion",
        title: "Bloqueo o alteración de información",
        subtypes: [
          {
            slug: "bloqueo-informativo",
            title: "Bloqueo informativo"
          },
          {
            slug: "compra-o-robo-masivo-de-publicaciones",
            title: "Compra o robo masivo de publicaciones"
          },
          {
            slug: "alteracion-de-contenido",
            title: "Alteración de contenido"
          }
        ]
      },
      {
        slug: "acceso-ilicito",
        title: "Acceso ilícito",
        subtypes: [
          {
            slug: "tentativa-de-acceso",
            title: "Tentativa de acceso"
          },
          {
            slug: "phishing",
            title: "Phishing"
          },
          {
            slug: "suplantacion-de-identidad",
            title: "Suplantación de identidad"
          },
          {
            slug: "sustraccion-de-informacion",
            title: "Sustracción de información"
          },
          {
            slug: "modificacion-de-contenido",
            title: "Modificación de contenido"
          }
        ]
      },
      {
        slug: "vigilancia-ilegal-de-comunicaciones",
        title: "Vigilancia ilegal de comunicaciones",
        subtypes: [
          {
            slug: "telefonica",
            title: "Telefónica"
          },
          {
            slug: "malware",
            title: "Malware"
          },
          {
            slug: "conexion-no-autorizada-a-servidores-y-sistemas-de-redes",
            title: "Conexión no autorizada a servidores y sistemas de redes"
          }
        ]
      },
      {
        slug: "remocion-de-contenido",
        title: "Remoción de contenido",
        subtypes: [
          {
            slug: "uso-indebido-de-normas-de-la-proteccion-de-datos-personales",
            title: "Uso indebido de normas de la protección de datos personales"
          },
          {
            slug: "uso-indebido-de-normas-de-propiedad-intelectual",
            title: "Uso indebido de normas de propiedad intelectual"
          },
          {
            slug: "normas-o-reglas-de-la-plataforma-de-red-social",
            title: "Normas o reglas de la plataforma de red social"
          }
        ]
      },
      {
        slug: "interrupcion-de-servicios-de-internet-y-telecomunicaciones",
        title: "Interrupción de servicios de internet y telecomunicaciones",
        subtypes: [
          {
            slug: "interrupcion-de-servicios-de-internet",
            title: "Interrupción de servicios de internet"
          },
          {
            slug: "interrupcion-de-servicios-de-telecomunicaciones",
            title: "Interrupción de servicios de telecomunicaciones"
          }
        ]
      },
      {
        slug: "dominios-o-cuentas-falsas",
        title: "Dominios o cuentas falsas",
        subtypes: [
          {
            slug: "suplantacion-de-servicios-de-mensajeria-o-telefonica",
            title: "Suplantación de servicios de mensajería o telefónica"
          },
          {
            slug: "cuentas-o-perfiles-en-redes-sociales",
            title: "Cuentas o perfiles en redes sociales"
          },
          {
            slug: "sitio-web",
            title: "Sitio web"
          }
        ]
      },
      {
        slug: "ataque-o-denegacion-de-servicio",
        title: "Ataque o denegación de servicio",
        subtypes: [
          {
            slug: "dos",
            title: "DoS"
          },
          {
            slug: "ddos",
            title: "DDoS"
          }
        ]
      }
    ],
    contextColor: "#dee2e6",
    patchColors: [
 {
   "cve_ent": 1,
   "nom_ent": "Aguascalientes",
   "zona": "Zona Occidente",
   "color": "#E37230"
 },
 {
   "cve_ent": 2,
   "nom_ent": "Baja California",
   "zona": "Zona Noroeste",
   "color": "#E32980"
 },
 {
   "cve_ent": 3,
   "nom_ent": "Baja California Sur",
   "zona": "Zona Noroeste",
   "color": "#E32980"
 },
 {
   "cve_ent": 4,
   "nom_ent": "Campeche",
   "zona": "Zona Sureste",
   "color": "#3268C2"
 },
 {
   "cve_ent": 5,
   "nom_ent": "Coahuila",
   "zona": "Zona Noreste",
   "color": "#8366B5"
 },
 {
   "cve_ent": 6,
   "nom_ent": "Colima",
   "zona": "Zona Occidente",
   "color": "#E37230"
 },
 {
   "cve_ent": 7,
   "nom_ent": "Chiapas",
   "zona": "Zona Sureste",
   "color": "#3268C2"
 },
 {
   "cve_ent": 8,
   "nom_ent": "Chihuahua",
   "zona": "Zona Noroeste",
   "color": "#E32980"
 },
 {
   "cve_ent": 10,
   "nom_ent": "Durango",
   "zona": "Zona Noreste",
   "color": "#8366B5"
 },
 {
   "cve_ent": 11,
   "nom_ent": "Guanajuato",
   "zona": "Zona Occidente",
   "color": "#E37230"
 },
 {
   "cve_ent": 12,
   "nom_ent": "Guerrero",
   "zona": "Zona Centro",
   "color": "#48961E"
 },
 {
   "cve_ent": 13,
   "nom_ent": "Hidalgo",
   "zona": "Zona Centro",
   "color": "#48961E"
 },
 {
   "cve_ent": 14,
   "nom_ent": "Jalisco",
   "zona": "Zona Occidente",
   "color": "#E37230"
 },
 {
   "cve_ent": 15,
   "nom_ent": "Estado de México",
   "zona": "Zona Centro",
   "color": "#48961E"
 },
 {
   "cve_ent": 16,
   "nom_ent": "Michoacán",
   "zona": "Zona Occidente",
   "color": "#E37230"
 },
 {
   "cve_ent": 17,
   "nom_ent": "Morelos",
   "zona": "Zona Centro",
   "color": "#48961E"
 },
 {
   "cve_ent": 18,
   "nom_ent": "Nayarit",
   "zona": "Zona Occidente",
   "color": "#E37230"
 },
 {
   "cve_ent": 19,
   "nom_ent": "Nuevo León",
   "zona": "Zona Noreste",
   "color": "#8366B5"
 },
 {
   "cve_ent": 20,
   "nom_ent": "Oaxaca",
   "zona": "Zona Sureste",
   "color": "#3268C2"
 },
 {
   "cve_ent": 21,
   "nom_ent": "Puebla",
   "zona": "Zona Centro",
   "color": "#48961E"
 },
 {
   "cve_ent": 22,
   "nom_ent": "Querétaro",
   "zona": "Zona Occidente",
   "color": "#E37230"
 },
 {
   "cve_ent": 23,
   "nom_ent": "Quintana Roo",
   "zona": "Zona Sureste",
   "color": "#3268C2"
 },
 {
   "cve_ent": 24,
   "nom_ent": "San Luis Potosí",
   "zona": "Zona Noreste",
   "color": "#8366B5"
 },
 {
   "cve_ent": 25,
   "nom_ent": "Sinaloa",
   "zona": "Zona Noroeste",
   "color": "#E32980"
 },
 {
   "cve_ent": 26,
   "nom_ent": "Sonora",
   "zona": "Zona Noroeste",
   "color": "#E32980"
 },
 {
   "cve_ent": 27,
   "nom_ent": "Tabasco",
   "zona": "Zona Sureste",
   "color": "#3268C2"
 },
 {
   "cve_ent": 28,
   "nom_ent": "Tamaulipas",
   "zona": "Zona Noreste",
   "color": "#8366B5"
 },
 {
   "cve_ent": 29,
   "nom_ent": "Tlaxcala",
   "zona": "Zona Centro",
   "color": "#48961E"
 },
 {
   "cve_ent": 30,
   "nom_ent": "Veracruz",
   "zona": "Zona Sureste",
   "color": "#3268C2"
 },
 {
   "cve_ent": 31,
   "nom_ent": "Yucatán",
   "zona": "Zona Sureste",
   "color": "#3268C2"
 },
 {
   "cve_ent": 32,
   "nom_ent": "Zacatecas",
   "zona": "Zona Occidente",
   "color": "#E37230"
 },
 {
   "cve_ent": 9,
   "nom_ent": "Ciudad de México",
   "zona": "Zona Centro",
   "color": "#48961E"
 }
],
    host:
      process.env.NODE_ENV === "production"
        ? "https://admin-rompeelmiedo.datacivica.org/"
        : "http://localhost:1337/",
    reports: [],
    filteredReports: [],
    filters: {},
    isLoading: false,
    user: {
      email: "",
      role: "",
      isAuthenticated: false
    },
    contexts: [],
    currentToken: "",

    getReportsAsyncPending: false,
    getReportsAsyncStatusCode: null,
    getReportsAsyncData: null,

    createReportAsyncPending: false,
    createReportAsyncStatusCode: null,
    createReportAsyncData: null,

    updateReportAsyncPending: false,
    updateReportAsyncStatusCode: null,
    updateReportAsyncData: null,

    deleteReportAsyncPending: false,
    deleteReportAsyncStatusCode: null,
    deleteReportAsyncData: null,

    uploadImageAsyncPending: false,
    uploadImageAsyncStatusCode: null,
    uploadImageAsyncData: null,

    updateCsvAsyncPending: false,
    updateCsvAsyncStatusCode: null,
    updateCsvAsyncData: null,

    updateContextsCsvAsyncPending: false,
    updateContextsCsvAsyncStatusCode: null,
    updateContextsCsvAsyncData: null,

    loginAsyncPending: false,
    loginAsyncStatusCode: null,
    loginAsyncData: null,

    addReviewAsyncPending: false,
    addReviewAsyncStatusCode: null,
    addReviewAsyncData: null
  },
  getters: {
    record: state => state.record,
    stateColors: state => state.stateColors,
    reports: state => state.reports,
    filteredReports: state => state.filteredReports,
    filters: state => state.filters,
    contexts: state => state.contexts
  },
  mutations: {
    setEditionState(state, edit) {
      state.editing = edit;
    },
    setIsLoadingState(state, isLoading) {
      state.isLoading = isLoading;
    },
    setRecord(state, item) {
      state.record = item;
      state.record.id = state.record["_id"];
    },
    resetRecord(state) {
      state.record = {
        id: undefined,
        folio: undefined,
        aggression_datetime: undefined,
        verification_datetime: undefined,
        alert_link: undefined,
        aggression_type: [],
        aggression_subtype: [],
        details: undefined,
        state: undefined,
        municipality: undefined,
        place: undefined,
        address: undefined,
        lat: undefined,
        lng: undefined,
        victims: [],
        updates: [],
        reviews: [],
        public: true,
        edit_reason: undefined,
        edit_comments: undefined,
        review_reason: undefined,
        review_comments: undefined
      };
    },
    resetReview(state) {
      state.record.review_reason = undefined;
      state.record.review_comments = undefined;
    },
    setUser(state, user) {
      state.user = user;
      localStorage.setItem(
        "rompeelmiedo.org",
        JSON.stringify({ user: state.user })
      );
    },
    resetUser(state) {
      state.user = {
        email: "",
        role: "",
        isAuthenticated: false
      };
      localStorage.clear();
    },

    SET_GETREPORTS_PENDING(state, payload) {
      state.getReportsAsyncPending = payload.pending;
    },
    SET_GETREPORTS_SUCCESS(state, payload) {
      state.getReportsAsyncStatusCode = payload.statusCode;
      state.getReportsAsyncData = payload.data;
      state.getReportsAsyncPending = payload.pending;
      // console.log(payload.data.result)
      state.reports = payload.data.result;
      const filters = {};
      state.reports.map(report => (filters[report.type] = false));
      state.filteredReports = state.reports;
      state.filters = filters;
      //console.log(state.reports)
      //console.log(state.filteredReports)
    },
    SET_GETREPORTS_FAILURE(state, payload) {
      state.getReportsAsyncStatusCode = payload.statusCode;
    },

    SET_CREATEREPORT_PENDING(state, payload) {
      state.createReportAsyncPending = payload.pending;
    },
    SET_CREATEREPORT_SUCCESS(state, payload) {
      state.createReportAsyncStatusCode = payload.statusCode;
      state.createReportAsyncData = payload.data;
      state.createReportAsyncPending = payload.pending;
    },
    SET_CREATEREPORT_FAILURE(state, payload) {
      state.createReportAsyncStatusCode = payload.statusCode;
    },

    SET_UPDATEREPORT_PENDING(state, payload) {
      state.updateReportAsyncPending = payload.pending;
    },
    SET_UPDATEREPORT_SUCCESS(state, payload) {
      state.updateReportAsyncStatusCode = payload.statusCode;
      state.updateReportAsyncData = payload.data;
      state.updateReportAsyncPending = payload.pending;
      // console.log(payload.data.result.value)
    },
    SET_UPDATEREPORT_FAILURE(state, payload) {
      state.updateReportAsyncStatusCode = payload.statusCode;
    },

    SET_DELETEREPORT_PENDING(state, payload) {
      state.deleteReportAsyncPending = payload.pending;
    },
    SET_DELETEREPORT_SUCCESS(state, payload) {
      state.deleteReportAsyncStatusCode = payload.statusCode;
      state.deleteReportAsyncData = payload.data;
      state.deleteReportAsyncPending = payload.pending;
    },
    SET_DELETEREPORT_FAILURE(state, payload) {
      state.deleteReportAsyncStatusCode = payload.statusCode;
    },
    SET_UPLOADIMAGE_PENDING(state, payload) {
      state.uploadImageAsyncPending = payload.pending;
    },
    SET_UPLOADIMAGE_SUCCESS(state, payload) {
      state.uploadImageAsyncStatusCode = payload.statusCode;
      state.uploadImageAsyncData = payload.data;
      state.uploadImageAsyncPending = payload.pending;
    },
    SET_UPLOADIMAGE_FAILURE(state, payload) {
      state.uploadImageAsyncStatusCode = payload.statusCode;
    },
    SET_UPDATECSV_PENDING(state, payload) {
      state.updateCsvAsyncPending = payload.pending;
    },
    SET_UPDATECSV_SUCCESS(state, payload) {
      state.updateCsvAsyncStatusCode = payload.statusCode;
      state.updateCsvAsyncData = payload.data;
      state.updateCsvAsyncPending = payload.pending;
    },
    SET_UPDATECSV_FAILURE(state, payload) {
      state.updateCsvAsyncStatusCode = payload.statusCode;
    },
    SET_UPDATECONTEXTSCSV_PENDING(state, payload) {
      state.updateContextsCsvAsyncPending = payload.pending;
    },
    SET_UPDATECONTEXTSCSV_SUCCESS(state, payload) {
      state.updateContextsCsvAsyncStatusCode = payload.statusCode;
      state.updateContextsCsvAsyncData = payload.data;
      state.updateContextsCsvAsyncPending = payload.pending;
    },
    SET_UPDATECONTEXTSCSV_FAILURE(state, payload) {
      state.updateContextsCsvAsyncStatusCode = payload.statusCode;
    },
    SET_LOGIN_PENDING(state, payload) {
      state.loginAsyncPending = payload.pending;
    },
    SET_LOGIN_SUCCESS(state, payload) {
      state.loginAsyncStatusCode = payload.statusCode;
      state.loginAsyncData = payload.data;
      state.loginAsyncPending = payload.pending;
    },
    SET_LOGIN_FAILURE(state, payload) {
      state.loginAsyncStatusCode = payload.statusCode;
    },
    SET_ADDREVIEW_PENDING(state, payload) {
      state.addReviewAsyncPending = payload.pending;
    },
    SET_ADDREVIEW_SUCCESS(state, payload) {
      state.addReviewAsyncStatusCode = payload.statusCode;
      state.addReviewAsyncData = payload.data;
      state.addReviewAsyncPending = payload.pending;
    },
    SET_ADDREVIEW_FAILURE(state, payload) {
      state.addReviewAsyncStatusCode = payload.statusCode;
    },
    updateAggressionDateTime(state, datetime) {
      state.record["aggression_datetime"] = datetime;
    },
    updateVerificationDateTime(state, datetime) {
      state.record["verification_datetime"] = datetime;
    },
    updateAlertLink(state, link) {
      state.record["alert_link"] = link;
    },
    updateAggressionType(state, type) {
      state.record["aggression_type"] = type;
    },
    updateAggressionSubtype(state, type) {
      state.record["aggression_subtype"] = type;
    },
    updateDetails(state, details) {
      state.record.details = details;
    },
    updateState(state, _state) {
      state.record.state = _state;
    },
    updateMunicipality(state, mun) {
      state.record.municipality = mun;
    },
    updateVictims(state, victims) {
      state.record.victims = victims;
    },
    updatePlace(state, place) {
      state.record.place = place;
    },
    updateAddress(state, address) {
      state.record.address = address;
    },
    updateLat(state, lat) {
      state.record.lat = lat;
    },
    updateLng(state, lng) {
      state.record.lng = lng;
    },
    updateEditReason(state, edit_reason) {
      state.record["edit_reason"] = edit_reason;
    },
    updateEditComments(state, edit_comments) {
      state.record["edit_comments"] = edit_comments;
    },
    updateReviewReason(state, review_reason) {
      state.record["review_reason"] = review_reason;
    },
    updateReviewComments(state, review_comments) {
      state.record["review_comments"] = review_comments;
    },
    updatePublic(state, _public) {
      state.record.public = _public;
    }
  },
  actions: {
    getReports({ state, commit }) {
      commit("SET_GETREPORTS_PENDING", { pending: true });
      axios
        .get(state.host + "api/v1/reports", {
          params: {}
        })
        .then(response => {
          commit("SET_GETREPORTS_SUCCESS", {
            pending: false,
            statusCode: response.status,
            data: response.data
          });
        })
        .catch(error => {
          // console.log(error);
          commit("SET_GETREPORTS_FAILURE", {
            pending: false,
            statusCode: error.status
          });
        });
    },
    createReport({ state, commit }) {
      state.record.updates.push({
        when: new Date(),
        who: state.user.email,
        changes: "Registro inicial",
        comments: "Registro inicial" /*,
        report: {...state.record}*/
      });
      commit("SET_CREATEREPORT_PENDING", { pending: true });
      return axios.post(state.host + "api/v1/reports", {
        features: state.record
      });
    },
    updateReport({ state, commit }) {
      state.record.updates.push({
        when: new Date(),
        who: state.user.email,
        changes:
          state.record["edit_reason"] === "update"
            ? "Actualización del caso"
            : "Corrección de errores",
        comments:
          state.record["edit_comments"] /*,
        report: {...state.record}*/
      });
      state.record.reviews = [];
      commit("SET_UPDATEREPORT_PENDING", { pending: true });
      return axios.put(state.host + "api/v1/reports", {
        features: state.record
      });
    },
    deleteReport({ state, commit }) {
      commit("SET_DELETEREPORT_PENDING", { pending: true });
      return axios.delete(state.host + "api/v1/reports", {
        params: {
          id: state.record.id,
          folio: state.record.folio
        }
      });
    },
    uploadImage({ state, commit }, imageData) {
      commit("SET_UPLOADIMAGE_PENDING", { pending: true });

      return axios.post(state.host + "api/v1/images", imageData);
    },
    updateCsv({ state, commit }) {
      commit("SET_UPDATECSV_PENDING", { pending: true });

      return axios.post(state.host + "api/v1/generateCsv");
    },
    login({ state, commit }, userData) {
      commit("SET_LOGIN_PENDING", { pending: true });
      return axios.post(state.host + "api/v1/login", {
        email: userData.email,
        password: userData.password
      });
    },
    addReview({ state, commit }) {
      // console.log(state.record.reviews)
      state.record.reviews.push({
        when: new Date(),
        who: state.user.email,
        changes:
          state.record["review_reason"] === "right"
            ? "La postal es correcta"
            : "La postal tiene errores",
        comments: state.record["review_comments"]
      });
      commit("SET_ADDREVIEW_PENDING", { pending: true });
      return axios.put(state.host + "api/v1/reports", {
        features: state.record
      });
    },
    addToken({ state }) {
      // commit('SET_ADDTOKEN_PENDING', { pending: true })
      return axios.post(state.host + "api/v1/token", {
        email: state.user.email,
        role: state.user.role,
        token: state.currentToken
      });
    },
    sendPushNotification({ state }, notification) {
      // commit('SET_ADDTOKEN_PENDING', { pending: true })
      return axios.post(state.host + "api/v1/notification", {
        notification: notification
      });
    },
    async getContexts({ state }) {
      try {
        const response = await axios.get(state.host + "api/v1/contexts");
        state.contexts = response.data.result;
      } catch (error) {
        console.log(error, "error");
      }
    },
    async createContext({ state }, params) {
      return axios.post(state.host + "api/v1/context", {
        context: params.field,
        contextId: params.fieldId,
        color: params.color
      });
    },
    updateContextsCsv({ state, commit }) {
      commit("SET_UPDATECONTEXTSCSV_PENDING", { pending: true });

      return axios.post(state.host + "api/v1/generateContextsCsv");
    },
  }
});
